<input
    type="checkbox"
    matTooltip="{{ tooltip }}"
    class="ui-switch__input"
    [id]="uuid"
    [checked]="checked"
    [disabled]="disabled"
    [value]="value"
    (change)="onToggle($event)"
/>

<label [for]="id"
       class="ui-switch {{ color }}"
       [ngClass]="{ 'ui-switch__disabled': disabled }"
>
    <ng-content></ng-content>
</label>
@if (label) {
    <label [for]="id"
           class="ui-switch__label"
           [innerHTML]="label"
    ></label>
}
